import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../utils/data-load-error/data-load-error";

export enum CandidatureDeleteOrderErrorType {
  TAXI_DRIVER_ASSOCIATION_NOT_EXISTS = "TAXI_DRIVER_ASSOCIATION_NOT_EXISTS",
  TAXI_DRIVER_CONTRACT_NOT_VALID = "TAXI_DRIVER_CONTRACT_NOT_VALID",
  TAXI_RAILY_CONTRACT_NOT_VALID = "TAXI_RAILY_CONTRACT_NOT_VALID",
  ORDER_NOT_EXISTS = "ORDER_NOT_EXISTS",
  ORDER_IN_PROGRESS = "ORDER_IN_PROGRESS",
  DRIVER_HAS_CANDIDATURE = "DRIVER_HAS_CANDIDATURE",
}

export type CandidatureDeleteOrderTaxiDriverAssociationNotExistsError =
  DataLoadError<
    CandidatureDeleteOrderErrorType.TAXI_DRIVER_ASSOCIATION_NOT_EXISTS,
    {}
  >;

export type CandidatureDeleteOrderTaxiDriverContractNotValidError =
  DataLoadError<
    CandidatureDeleteOrderErrorType.TAXI_DRIVER_CONTRACT_NOT_VALID,
    {}
  >;

export type CandidatureDeleteOrderTaxiRailyContractNotExistsError =
  DataLoadError<
    CandidatureDeleteOrderErrorType.TAXI_RAILY_CONTRACT_NOT_VALID,
    {}
  >;

export type CandidatureDeleteOrderOrderNotExistsError = DataLoadError<
  CandidatureDeleteOrderErrorType.ORDER_NOT_EXISTS,
  {}
>;

export type CandidatureDeleteOrderOrderInProgressError = DataLoadError<
  CandidatureDeleteOrderErrorType.ORDER_IN_PROGRESS,
  {}
>;

export type CandidatureDeleteOrderDriverHasCandidatureError = DataLoadError<
  CandidatureDeleteOrderErrorType.DRIVER_HAS_CANDIDATURE,
  {}
>;

type CandidatureDeleteOrderError =
  | DataLoadDefaultErrors
  | CandidatureDeleteOrderTaxiDriverAssociationNotExistsError
  | CandidatureDeleteOrderTaxiDriverContractNotValidError
  | CandidatureDeleteOrderTaxiRailyContractNotExistsError
  | CandidatureDeleteOrderOrderNotExistsError
  | CandidatureDeleteOrderOrderInProgressError
  | CandidatureDeleteOrderDriverHasCandidatureError;

export default CandidatureDeleteOrderError;
